import React from 'react';
import { observer } from 'mobx-react';

export interface ISoundSelection {
    isMute: boolean;
    toggleIsMute: () => void;
}

export const SoundSelection = observer((props: ISoundSelection) => {
    return <div className="sound-toggle action-button hand" onClick={props.toggleIsMute}>
        <a>
            <i className={"fa fa-lg " + (props.isMute ? "fa-volume-off" : "fa-volume-up")}>
            </i>
            {/** tooltip Zapnúť zvuk (iba pre Vybrané zápasy) */}
        </a>
    </div>
});